export default __webpack_public_path__ + "b44d0c38ef0f202cfd25b45bd739e0c4.woff2";